var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('span',{staticClass:"pa-3 white--text font-weight-bold text-uppercase text-h3 d-inline-block"},[_vm._v("Collection")])]),_c('CollectionComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }